import React from "react";

/**
 * Click handler for external links that ensures they open in a new tab,
 * even when the app is rendered inside an iframe (e.g. Lovable preview).
 */
export function handleExternalClick(e: React.MouseEvent<HTMLAnchorElement>) {
  const href = e.currentTarget.href;
  if (href) {
    e.preventDefault();
    window.open(href, "_blank", "noopener,noreferrer");
  }
}
